import { useState, useEffect } from 'react';

// Global userInfo store for React 16 compatibility
let globalUserInfo = {
  data: null,
  isInitialized: false,
};

let subscribers = [];

const notifySubscribers = () => {
  subscribers.forEach(callback => callback(globalUserInfo));
};

// Store actions
export const userInfoActions = {
  setData: data => {
    globalUserInfo = {
      data,
      isInitialized: true,
    };
    notifySubscribers();
  },
};

// Hook to access userInfo from store
export const useUserInfoStore = () => {
  const [state, setState] = useState(globalUserInfo);

  useEffect(() => {
    const unsubscribe = () => {
      setState({ ...globalUserInfo });
    };

    subscribers.push(unsubscribe);

    return () => {
      subscribers = subscribers.filter(sub => sub !== unsubscribe);
    };
  }, []);

  return state;
};
